module.exports = __webpack_public_path__ + "static/media/29.4da8e27e.mp4";